import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Collaborators from "@/pages/Collaborators";
import CollaboratorDetail from "@/pages/CollaboratorDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Production from "@/pages/Production";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import SOPList from "@/pages/SOPList";
import SOPEdit from "@/pages/SOPEdit";
import Successi from "@/pages/Successi";
import InternalProjects from "@/pages/InternalProjects";
import PolicyList from "@/pages/PolicyList";
import PolicyEdit from "@/pages/PolicyEdit";
import TimeMachine from "@/pages/TimeMachine";
import DailyPlans from "@/pages/DailyPlans";

function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const loc = useLocation();
    if (user === undefined) return <div className="p-8 text-sm text-neutral-500">Caricamento…</div>;
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    return children;
}

function AdminOnly({ children }) {
    const { user } = useAuth();
    if (!user) return null;
    if (user.role !== "admin") return <Navigate to="/" replace />;
    return children;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                        <Route index element={<Dashboard />} />
                        <Route path="clienti" element={<Clients />} />
                        <Route path="clienti/:id" element={<ClientDetail />} />
                        <Route path="collaboratori" element={<Collaborators />} />
                        <Route path="collaboratori/:id" element={<CollaboratorDetail />} />
                        <Route path="progetti" element={<Projects />} />
                        <Route path="progetti/:id" element={<ProjectDetail />} />
                        <Route path="progetti-interni" element={<InternalProjects />} />
                        <Route path="successi" element={<Successi />} />
                        <Route path="produzione" element={<Production />} />
                        <Route path="sop" element={<SOPList />} />
                        <Route path="sop/:id" element={<SOPEdit />} />
                        <Route path="policy" element={<PolicyList />} />
                        <Route path="policy/:id" element={<PolicyEdit />} />
                        <Route path="time-machine" element={<TimeMachine />} />
                        <Route path="piani-giornalieri" element={<DailyPlans />} />
                        <Route path="profilo" element={<Profile />} />
                        <Route path="impostazioni" element={<AdminOnly><Settings /></AdminOnly>} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
